import React, { useState } from "react";
import "./Book.css";
import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc } from "firebase/firestore";
import { db } from "../firebase";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import CustomDatePicker from "../Components/CustomDatePicker";
import LocationAutocomplete from "../Components/LocationAutocomplete";

function Book() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    startDate: null,
    endDate: null,
    location: "",
    equipment: {
      photobooth: false,
      speaker1: false,
      speaker2: false,
      smokeMachine: false,
      strobe: false,
    },
    additionalNeeds: "",
  });
  
  const [currentStep, setCurrentStep] = useState(1);
  const [formSubmitted, setFormSubmitted] = useState(false);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleEquipmentChange = (e) => {
    const { name, checked } = e.target;
    setFormData({
      ...formData,
      equipment: {
        ...formData.equipment,
        [name]: checked,
      },
    });
  };
  
  const handleNext = (e) => {
    e.preventDefault();
    setCurrentStep(currentStep + 1);
    window.scrollTo(0, 0);
  };
  
  const handlePrevious = () => {
    setCurrentStep(currentStep - 1);
    window.scrollTo(0, 0);
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // First, save to Firestore
      await addDoc(collection(db, "reservations"), {
        ...formData,
        daysOfUse: calculateDays(),
        timestamp: new Date(),
        // Sauvegarder les dates au format ISO pour cohérence
        startDateISO: formData.startDate ? formData.startDate.toISOString() : null,
        endDateISO: formData.endDate ? formData.endDate.toISOString() : null,
      });
      console.log("Data saved successfully to Firestore");
      
      // Then, send email notification
      try {
        const response = await fetch(
          "https://us-central1-photobooth-cccd9.cloudfunctions.net/sendSuperbText",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              firstName: formData.firstName,
              lastName: formData.lastName,
              email: formData.email,
              phone: formData.phone,
              startDate: formData.startDate ? formData.startDate.toISOString() : null,
              endDate: formData.endDate ? formData.endDate.toISOString() : null,
              daysOfUse: calculateDays(),
              location: formData.location,
              equipment: formData.equipment,
              equipmentPrice: calculateEquipmentPrice(),
              totalPrice: calculateTotalPrice(),
              additionalNeeds: formData.additionalNeeds || "",
            }),
          }
        );
  
        if (!response.ok) {
          throw new Error('Failed to send email notification');
        }
  
        const data = await response.json();
        console.log("Email notification sent successfully:", data);
      } catch (emailError) {
        console.error("Error sending email notification:", emailError);
        // Continue with form submission even if email fails
      }
      
      // Set form as submitted regardless of email success
      setFormSubmitted(true);
    } catch (error) {
      console.error("Error saving data to Firestore:", error);
      // You could add user notification here
    }
  };
  
  const resetForm = () => {
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      startDate: null,
      endDate: null,
      location: "",
      equipment: {
        photobooth: false,
        speaker1: false,
        speaker2: false,
        smokeMachine: false,
        strobe: false,
      },
      additionalNeeds: "",
    });
    setFormSubmitted(false);
    setCurrentStep(1);
  };

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setFormData({
      ...formData,
      startDate: start,
      endDate: end,
    });
  };

  const calculateDays = () => {
    if (formData.startDate && formData.endDate) {
      const timeDifference = formData.endDate.getTime() - formData.startDate.getTime();
      const dayDifference = Math.ceil(timeDifference / (1000 * 3600 * 24)) + 1;
      return Math.max(1, dayDifference); // Minimum 1 jour
    }
    return 0;
  };
  const days = calculateDays();

  const calculateEquipmentPrice = () => {
    let total = 0;

    // Prix du photobooth en fonction du nombre de jours
    if (formData.equipment.photobooth && days > 0) {
      if (days === 1) total += 200;
      else if (days === 2) total += 300;
      else if (days === 3) total += 350;
      else if (days > 3) total += 350 + (days - 3) * 50; // 50€ par jour supplémentaire après 3 jours
    }

    // Autres équipements (prix par jour)
    if (days > 0) {
      if (formData.equipment.speaker1) total += 50 * days;
      if (formData.equipment.speaker2) total += 80 * days;
      if (formData.equipment.smokeMachine) total += 40 * days;
      if (formData.equipment.strobe) total += 20 * days;
    }

    return total;
  };

  const calculateTotalPrice = () => {
    return calculateEquipmentPrice();
  };

  const hasEquipmentSelected = () => {
    return Object.values(formData.equipment).some(value => value === true);
  };

  const estimatedPrice =
    (() => {
      const total = calculateTotalPrice();
      if (total === 0) {
        if (!hasEquipmentSelected()) {
          return "Sélectionnez du matériel";
        }
        return "Sélectionnez des dates";
      }
      return `${total} €`;
    })();
  

  return (
    <div className="div">


    <div className="book-container">
     {/*  <div className="book-header">
        <h1>Prise de contact</h1>
      </div> */}

      {!formSubmitted ? (
        <div className="form-container">
          <div className="steps-indicator">
            <div
              className={`step ${currentStep >= 1 ? "active" : ""}`}
              onClick={() => currentStep > 1 && setCurrentStep(1)}
              style={{ cursor: currentStep > 1 ? 'pointer' : 'default' }}
            >
              <div className="step-number">1</div>
              <span className="step-label">Informations</span>
            </div>
            <div className="step-connector"></div>
            <div
              className={`step ${currentStep >= 2 ? "active" : ""}`}
              onClick={() => currentStep > 2 && setCurrentStep(2)}
              style={{ cursor: currentStep > 2 ? 'pointer' : 'default' }}
            >
              <div className="step-number">2</div>
              <span className="step-label">Détails</span>
            </div>
            <div className="step-connector"></div>
            <div className={`step ${currentStep >= 3 ? "active" : ""}`}>
              <div className="step-number">3</div>
              <span className="step-label">Confirmation</span>
            </div>
          </div>
          <form onSubmit={currentStep === 3 ? handleSubmit : handleNext}>
            {currentStep === 1 && (
              <div className="form-step">
                <h2>Vos coordonnées</h2>
                <p className="form-intro">
                  Pour commencer, nous avons besoin de quelques informations pour vous contacter.
                </p>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="lastName">Nom</label>
                    <input
                      type="text"
                      id="lastName"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                      placeholder="Votre nom"
                    />
                  </div>
                  
                  <div className="form-group specialmargin">
                    <label htmlFor="firstName">Prénom</label>
                    <input
                      type="text"
           
                      id="firstName"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                      placeholder="Votre prénom"
                    />
                  </div>
                </div>
                
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="votre.email@exemple.com"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="phone">Numéro de téléphone</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    placeholder="06 12 34 56 78"
                  />
                </div>
                
                <div className="form-actions">
                  <button type="submit" className="btn-next">
                    Continuer
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z" fill="currentColor"/>
                    </svg>
                  </button>
                </div>
              </div>
            )}
            
            {currentStep === 2 && (
              <div className="form-step">
                <h2>Détails de votre réservation</h2>
                <p className="form-intro">
                  Précisez la durée et vos besoins spécifiques pour que nous puissions vous proposer un devis adapté.
                </p>

                <div className="details-grid">
                  <div className="details-left">
                    <div className="form-group">
                      <label htmlFor="dateRange">Sélectionnez vos dates</label>
                      <CustomDatePicker
                        startDate={formData.startDate}
                        endDate={formData.endDate}
                        onChange={handleDateChange}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="location">Lieu de l'événement</label>
                      <LocationAutocomplete
                        value={formData.location}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="additionalNeeds">
                        Détails supplémentaires
                        <span className="label-optional">(optionnel)</span>
                      </label>
                      <textarea
                        id="additionalNeeds"
                        name="additionalNeeds"
                        value={formData.additionalNeeds}
                        onChange={handleChange}
                        placeholder="Décrivez l'événement, vos besoins spécifiques ou toute information utile pour votre réservation..."
                        rows="5"
                      ></textarea>
                    </div>
                  </div>

                  <div className="details-right">
                    <div className="form-group">
                      <label>Matériel souhaité</label>
                      <div className="equipment-list">
                        <label className="equipment-item">
                          <input
                            type="checkbox"
                            name="photobooth"
                            checked={formData.equipment.photobooth}
                            onChange={handleEquipmentChange}
                          />
                          <div className="equipment-image-small">
                            <img src={require("../img/woody.png")} alt="WoodyBooth" />
                          </div>
                          <span className="equipment-label">
                            Woodybooth
                            <span className="equipment-price">À partir de 200€</span>
                          </span>
                        </label>

                        <label className="equipment-item">
                          <input
                            type="checkbox"
                            name="speaker1"
                            checked={formData.equipment.speaker1}
                            onChange={handleEquipmentChange}
                          />
                          <div className="equipment-image-small">
                            <img src={require("../img/JBL 710 PNG.webp")} alt="JBL PartyBox 710" />
                          </div>
                          <span className="equipment-label">
                            1 Enceinte
                            <span className="equipment-price">50€/jour</span>
                          </span>
                        </label>

                        <label className="equipment-item">
                          <input
                            type="checkbox"
                            name="speaker2"
                            checked={formData.equipment.speaker2}
                            onChange={handleEquipmentChange}
                          />
                          <div className="equipment-image-small">
                            <img src={require("../img/Double enceinte JBL 710 PNG.png")} alt="Double JBL 710" />
                          </div>
                          <span className="equipment-label">
                            2 Enceintes
                            <span className="equipment-price">80€/jour</span>
                          </span>
                        </label>

                        <label className="equipment-item">
                          <input
                            type="checkbox"
                            name="smokeMachine"
                            checked={formData.equipment.smokeMachine}
                            onChange={handleEquipmentChange}
                          />
                          <div className="equipment-image-small">
                            <img src={require("../img/Smog Machine PNG.png")} alt="Machine à fumée" />
                          </div>
                          <span className="equipment-label">
                            Machine à fumée
                            <span className="equipment-price">40€/jour</span>
                          </span>
                        </label>

                        <label className="equipment-item">
                          <input
                            type="checkbox"
                            name="strobe"
                            checked={formData.equipment.strobe}
                            onChange={handleEquipmentChange}
                          />
                          <div className="equipment-image-small">
                            <img src={require("../img/Stroboscope PNG.png")} alt="Stroboscope 1500W" />
                          </div>
                          <span className="equipment-label">
                            Stroboscope
                            <span className="equipment-price">20€/jour</span>
                          </span>
                        </label>
                      </div>
                    </div>

                    <div className="estimated-price">
                      <p>Estimation du prix</p>
                      <h3>{estimatedPrice}</h3>

                      <span className="price-note">
                        {(() => {
                          const total = calculateTotalPrice();
                          if (total === 0) {
                            if (!hasEquipmentSelected()) {
                              return "Sélectionnez du matériel pour voir le prix estimé";
                            }
                            if (formData.equipment.photobooth) {
                              return "Sélectionnez vos dates pour voir le prix du photobooth";
                            }
                            return "Prix estimé en fonction du matériel sélectionné";
                          }
                          if (formData.equipment.photobooth && days > 0) {
                            return `Prix indicatif basé sur ${days} ${days === 1 ? "jour" : "jours"} d'utilisation`;
                          }
                          return "Prix estimé en fonction du matériel sélectionné";
                        })()}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="form-actions">
                  <button type="button" className="btn-back" onClick={handlePrevious}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 16L9.41 14.59L3.83 9H16V7H3.83L9.41 1.41L8 0L0 8L8 16Z" fill="currentColor"/>
                    </svg>
                    Retour
                  </button>
                  <button type="submit" className="btn-next">
                    Vérifier
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z" fill="currentColor"/>
                    </svg>
                  </button>
                </div>
              </div>
            )}
            
            {currentStep === 3 && (
              <div className="form-step">
                <h2>Résumé de votre demande</h2>
                <p className="form-intro">
                  Vérifiez les informations ci-dessous avant de finaliser votre demande de réservation.
                </p>
                
                <div className="summary-container">
                  <div className="summary-section">
                    <h3>Vos coordonnées</h3>
                    <div className="summary-row">
                      <span>Nom complet</span>
                      <span>{formData.firstName} {formData.lastName}</span>
                    </div>
                    <div className="summary-row">
                      <span>Email</span>
                      <span>{formData.email}</span>
                    </div>
                    <div className="summary-row">
                      <span>Téléphone</span>
                      <span>{formData.phone}</span>
                    </div>
                  </div>

                  <div className="summary-section">
                    <h3>Détails de réservation</h3>
                    <div className="summary-row">
                      <span>Dates</span>
                      <span>
                        {formData.startDate && formData.endDate
                          ? days === 1
                            ? `Le ${formData.startDate.toLocaleDateString('fr-FR')} (1 jour)`
                            : `Du ${formData.startDate.toLocaleDateString('fr-FR')} au ${formData.endDate.toLocaleDateString('fr-FR')} (${days} jours)`
                          : "Aucune date sélectionnée"
                        }
                      </span>
                    </div>
                    <div className="summary-row">
                      <span>Lieu</span>
                      <span>{formData.location}</span>
                    </div>
                  </div>

                  {(formData.equipment.photobooth || formData.equipment.speaker1 || formData.equipment.speaker2 || formData.equipment.smokeMachine || formData.equipment.strobe) && (
                    <div className="summary-section">
                      <h3>Matériel souhaité</h3>
                      <ul className="equipment-summary">
                        {formData.equipment.photobooth && (
                          <li>
                            Photobooth -{" "}
                            {days > 0
                              ? days === 1
                                ? "200€"
                                : days === 2
                                ? "300€"
                                : days === 3
                                ? "350€"
                                : `${350 + (days - 3) * 50}€`
                              : "Prix selon dates"}
                          </li>
                        )}
                        {formData.equipment.speaker1 && (
                          <li>1 Enceinte - {days > 0 ? `${50 * days}€` : "50€/jour"}</li>
                        )}
                        {formData.equipment.speaker2 && (
                          <li>2 Enceintes - {days > 0 ? `${80 * days}€` : "80€/jour"}</li>
                        )}
                        {formData.equipment.smokeMachine && (
                          <li>Machine à fumée - {days > 0 ? `${40 * days}€` : "40€/jour"}</li>
                        )}
                        {formData.equipment.strobe && (
                          <li>Stroboscope - {days > 0 ? `${20 * days}€` : "20€/jour"}</li>
                        )}
                      </ul>
                    </div>
                  )}

                  <div className="summary-section pricing">
                    <h3>Estimation</h3>
                    <div className="summary-price">
                      <span>Prix estimatif</span>
                      <span className="price">{estimatedPrice}</span>
                    </div>
                    <p className="price-disclaimer">
                      Ce prix est estimatif. Nous vous contacterons rapidement pour confirmer les détails et vous proposer un devis personnalisé.
                    </p>
                  </div>

                  {formData.additionalNeeds && (
                    <div className="summary-section full-width">
                      <h3>Détails supplémentaires</h3>
                      <p style={{margin: 0, lineHeight: 1.6}}>{formData.additionalNeeds}</p>
                    </div>
                  )}
                </div>
                
                <div className="consent-check">
                  <label className="checkbox-container">
                    <input type="checkbox" required />
                    <span className="checkmark"></span>
                    <span>
                      J'accepte que mes informations soient utilisées pour le traitement de ma demande de réservation, conformément à notre <a href="/privacy">politique de confidentialité</a> et nos <a href="/cgv">conditions générales de vente</a>
                    </span>
                  </label>
                </div>
                
                <div className="form-actions">
                  <button type="button" className="btn-back" onClick={handlePrevious}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 16L9.41 14.59L3.83 9H16V7H3.83L9.41 1.41L8 0L0 8L8 16Z" fill="currentColor"/>
                    </svg>
                    Modifier
                  </button>
                  <button type="submit" className="btn-submit">
                    Envoyer ma demande
                  </button>
                </div>
              </div>
            )}
          </form>
        </div>
      ) : (
        <div className="success-container">
          <div className="success-icon">
            <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="40" cy="40" r="40" fill="#0071E3" fillOpacity="0.1"/>
              <path d="M32 40L38 46L48 34" stroke="#0071E3" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="40" cy="40" r="28" stroke="#0071E3" strokeWidth="3"/>
            </svg>
          </div>
          <h2>Votre demande a bien été envoyée !</h2>
          <p>
            Merci {formData.firstName} pour votre demande de réservation. Nous l'avons bien reçue et un membre de notre équipe vous contactera à l'adresse <strong>{formData.email}</strong> sous 24 heures.
          </p>
          <p className="success-detail">
            Nous vous enverrons également une copie de votre demande par email pour vos archives.
          </p>
          <div className="success-actions">
            <button className="btn-new-reservation" onClick={resetForm}>
              Nouvelle réservation
            </button>
            <a href="/" className="btn-back-home">
              Retour à l'accueil
            </a>
          </div>
        </div>
      )}
    </div>
    <Footer />
    </div>
  );
}

export default Book;